import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store";
import App from "./App";
import "./index.css";

// Initialize Sentry FIRST — before any other code can throw
import { initSentry } from "./config/sentry";
initSentry();

// Initialize i18n
import "./config/i18n";

// Flight database health check
import { logFlightDatabaseHealth, validateFlightDatabase } from "./utils/flightDatabaseHealth";
import { captureMarketingAttribution } from "./utils/marketingAttribution";

// Validate flight database on startup
logFlightDatabaseHealth();
validateFlightDatabase();

// Preserve a complete tagged-landing bundle before routing or payment can
// replace the URL. Storage failures are swallowed inside the helper so this
// best-effort measurement can never stop the booking app from loading.
captureMarketingAttribution(window.location.search, window.location, window.localStorage, Date.now());

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element not found");
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
